import React from 'react';
import { Link } from 'react-router';

import useMartyContext from 'hooks/useMartyContext';
import Card from 'components/common/card/Card';
import CardMedia from 'components/common/card/CardMedia';

import { details, mainText, productLink, subText } from 'styles/components/common/productCard.scss';

const InlineProductCardAd = props => {
  const {
    className,
    mobilesrc,
    src,
    link,
    heading,
    subheading
  } = props;

  const { testId } = useMartyContext();

  const mediaProps = {
    mainImage: {
      src,
      srcSet: `${mobilesrc} 1x, ${src} 2x`
    },
    fullSizeImage: true,
    imageNoBackground: true
  };
  const productLabel = `${heading} ${subheading}`;

  return (
    <Card className={className}>
      <Link
        className={productLink}
        to={link}
        itemProp="url"
        data-test-id={testId('inlineProductAdLink')}>
        {productLabel}
      </Link>
      <CardMedia {...mediaProps}/>
      <dl className={details}>
        <dt>Title</dt>
        <dd className={mainText}>{heading}</dd>
        { subheading && (
          <>
            <dt>Description</dt>
            <dd className={subText}>{subheading}</dd>
          </>
        )}
      </dl>
    </Card>
  );
};

export default InlineProductCardAd;
